// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chat Container */
.chat-container {
    display: flex;
    flex-direction: column;
    padding: 1rem; /* Optional: Add padding around the chat */
}

/* Common Message Styles */
.message {
    margin: 0.2rem 0;
    padding: 0.5rem 1rem; /* Consistent horizontal padding for better readability */
    border-radius: 10px; /* Rounded corners like iMessage */
    max-width: 75%; /* Width adjustment for resemblance to iMessage */
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
    word-wrap: break-word;
    position: relative; /* For additional styling flexibility */
    display: inline-block; /* Ensures proper sizing of the message bubbles */
}

/* Assistant Message (Left-Aligned) */
.assistant-message {
    align-self: flex-start;
    background-color: #f1f1f3; /* iMessage light gray-v2 */
    color: black;
    margin-left: 0.5rem;
}

/* Tail for Assistant Message */
.assistant-message::before {
    content: '';
    position: absolute;
    bottom: 1px; /* Adjust as needed */
    left: -8px; /* Position the tail outside the bubble */
    border: 10px solid transparent;
    border-right-color: #f1f1f3; /* Same as bubble background */
    transform: rotate(-25deg); /* Rotate triangle to point left */
}

/* User Message (Right-Aligned) */
.user-message {
    align-self: flex-end;
    background-color: #007aff; /* iMessage blue */
    color: white;
    margin-right: 0.5rem;
}

/* Tail for User Message */
.user-message::after {
    content: '';
    position: absolute;
    bottom: 1px; /* Adjust as needed */
    right: -6px; /* Position the tail outside the bubble */
    border: 10px solid transparent; /* Chganges how big triangle is */
    border-left-color: #007aff; /* Same as bubble background */
    transform: rotate(25deg); /* Rotate triangle to point right */
}

/* Message Text */
.message-text {
    margin-top: 0.25rem; /* Margin-top using 'rem' for consistency */
    margin-bottom: 0.25rem; /* Margin-bottom */
    font-size: 1rem; /* Slightly larger font for readability */
    line-height: 1.5rem;  /* Line height for readability */
}

.message-text a {
    text-decoration: underline;
    color: inherit;
    font-weight: 550;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatWindow/Message.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa,EAAE,0CAA0C;AAC7D;;AAEA,0BAA0B;AAC1B;IACI,gBAAgB;IAChB,oBAAoB,EAAE,yDAAyD;IAC/E,mBAAmB,EAAE,kCAAkC;IACvD,cAAc,EAAE,iDAAiD;IACjE,wCAAwC,EAAE,4BAA4B;IACtE,qBAAqB;IACrB,kBAAkB,EAAE,uCAAuC;IAC3D,qBAAqB,EAAE,iDAAiD;AAC5E;;AAEA,qCAAqC;AACrC;IACI,sBAAsB;IACtB,yBAAyB,EAAE,2BAA2B;IACtD,YAAY;IACZ,mBAAmB;AACvB;;AAEA,+BAA+B;AAC/B;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW,EAAE,qBAAqB;IAClC,UAAU,EAAE,yCAAyC;IACrD,8BAA8B;IAC9B,2BAA2B,EAAE,8BAA8B;IAC3D,yBAAyB,EAAE,kCAAkC;AACjE;;AAEA,iCAAiC;AACjC;IACI,oBAAoB;IACpB,yBAAyB,EAAE,kBAAkB;IAC7C,YAAY;IACZ,oBAAoB;AACxB;;AAEA,0BAA0B;AAC1B;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW,EAAE,qBAAqB;IAClC,WAAW,EAAE,yCAAyC;IACtD,8BAA8B,EAAE,iCAAiC;IACjE,0BAA0B,EAAE,8BAA8B;IAC1D,wBAAwB,EAAE,mCAAmC;AACjE;;AAEA,iBAAiB;AACjB;IACI,mBAAmB,EAAE,2CAA2C;IAChE,sBAAsB,EAAE,kBAAkB;IAC1C,eAAe,EAAE,yCAAyC;IAC1D,mBAAmB,GAAG,gCAAgC;AAC1D;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;AACpB","sourcesContent":["/* Chat Container */\n.chat-container {\n    display: flex;\n    flex-direction: column;\n    padding: 1rem; /* Optional: Add padding around the chat */\n}\n\n/* Common Message Styles */\n.message {\n    margin: 0.2rem 0;\n    padding: 0.5rem 1rem; /* Consistent horizontal padding for better readability */\n    border-radius: 10px; /* Rounded corners like iMessage */\n    max-width: 75%; /* Width adjustment for resemblance to iMessage */\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */\n    word-wrap: break-word;\n    position: relative; /* For additional styling flexibility */\n    display: inline-block; /* Ensures proper sizing of the message bubbles */\n}\n\n/* Assistant Message (Left-Aligned) */\n.assistant-message {\n    align-self: flex-start;\n    background-color: #f1f1f3; /* iMessage light gray-v2 */\n    color: black;\n    margin-left: 0.5rem;\n}\n\n/* Tail for Assistant Message */\n.assistant-message::before {\n    content: '';\n    position: absolute;\n    bottom: 1px; /* Adjust as needed */\n    left: -8px; /* Position the tail outside the bubble */\n    border: 10px solid transparent;\n    border-right-color: #f1f1f3; /* Same as bubble background */\n    transform: rotate(-25deg); /* Rotate triangle to point left */\n}\n\n/* User Message (Right-Aligned) */\n.user-message {\n    align-self: flex-end;\n    background-color: #007aff; /* iMessage blue */\n    color: white;\n    margin-right: 0.5rem;\n}\n\n/* Tail for User Message */\n.user-message::after {\n    content: '';\n    position: absolute;\n    bottom: 1px; /* Adjust as needed */\n    right: -6px; /* Position the tail outside the bubble */\n    border: 10px solid transparent; /* Chganges how big triangle is */\n    border-left-color: #007aff; /* Same as bubble background */\n    transform: rotate(25deg); /* Rotate triangle to point right */\n}\n\n/* Message Text */\n.message-text {\n    margin-top: 0.25rem; /* Margin-top using 'rem' for consistency */\n    margin-bottom: 0.25rem; /* Margin-bottom */\n    font-size: 1rem; /* Slightly larger font for readability */\n    line-height: 1.5rem;  /* Line height for readability */\n}\n\n.message-text a {\n    text-decoration: underline;\n    color: inherit;\n    font-weight: 550;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
